module.exports = __webpack_public_path__ + "static/61323542_1286745714823831_8972800642623995904_o-(1)_optimized-44208d1a2642195fcb022e01fc6f6503.jpg";